// src/App.js
import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

// public
import ComingSoon from "./pages/ComingSoon";
import Login       from "./pages/Login";

// protected
import Sidebar           from "./components/Sidebar";
import Dashboard         from "./pages/Dashboard";
import Gallery           from "./pages/Gallery";
import Detection         from "./pages/Detection";
import DetectionGallery  from "./pages/DetectionGallery";
import Costs             from "./pages/Costs";
import Alerts            from "./pages/Alerts";
import Setting           from "./pages/Setting";

function PrivateRoute({ children }) {
  const isAuth = !!localStorage.getItem("auth");
  return isAuth ? children : <Navigate to="/login" replace />;
}

export default function App() {
  const [darkMode, setDarkMode] = useState(() => {
    return JSON.parse(localStorage.getItem("darkMode") || "false");
  });

  useEffect(() => {
    document.documentElement.classList.toggle("dark", darkMode);
    localStorage.setItem("darkMode", JSON.stringify(darkMode));
  }, [darkMode]);

  return (
    <Router>
      <Routes>
        {/* PUBLIC */}
        <Route path="/"      element={<ComingSoon />} />
        <Route path="/login" element={<Login />} />

        {/* PROTECTED */}
        <Route
          path="/app/*"
          element={
            <PrivateRoute>
              <div className={`flex ${darkMode ? "dark bg-slate-950" : "bg-slate-50"}`}>
                <Sidebar />
                <div className="flex-1 min-h-screen">
                  <Routes>
                    <Route index                          element={<Dashboard />} />
                    <Route path="gallery"                 element={<Gallery />} />
                    <Route path="detections"              element={<Detection />} />
                    <Route path="detections-gallery"      element={<DetectionGallery />} />
                    <Route path="costs"                   element={<Costs />} />
                    <Route path="alerts"                  element={<Alerts />} />
                    <Route path="setting" element={
                      <Setting darkMode={darkMode} setDarkMode={setDarkMode} />
                    }/>
                    {/* any unknown /app/... → back to Dashboard */}
                    <Route path="*" element={<Navigate to="/app" replace />} />
                  </Routes>
                </div>
              </div>
            </PrivateRoute>
          }
        />

        {/* anything else → back to ComingSoon */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}
